<template>
	<div
		ref="pageContainer"
		class="page-container"
		:id="index"
		:style="pdfStyle"
	>
		<slot></slot>
	</div>
</template>
<script>
	export default {
		name: 'PDFPage',
		emits: ['rendered', 'error'],
		props: ['page', 'index', 'width'],
		data() {
			return {
				scale: 1,
				viewport: null,
				renderFunction: null,
				isLoaded: false,
			};
		},
		computed: {
			canvasAttrs() {
				const width = this.viewport.width;
				const height = this.viewport.height;

				return {
					width: width,
					height: height,
					class: 'pdf-page',
				};
			},
			pdfStyle() {
				return `height: ${this.canvasAttrs.height}px; width: ${this.canvasAttrs.width}px;`;
			},
		},

		created() {
			//console.log('this.width', this.width);
			//console.log('this.page.getViewport({ scale: 1 }).width', this.page.getViewport({ scale: 1 }).width);
			//console.log('window.devicePixelRatio', (window.devicePixelRatio || 1));

			//const scale = this.width / this.page.getViewport({ scale: 1 }).width * (window.devicePixelRatio || 1);
			const scale = this.width / this.page.getViewport({ scale: 1 }).width;
			const scaleOverride = 1;
			this.viewport = this.page.getViewport({ scale: scale });
			//console.log('this.viewport', this.viewport);
		},
		// render(h) {
		//     const attrs = this.canvasAttrs;
		//     const pageId = this.index;
		//     return (
		//         <div ref="pageContainer" class="page-container" id={pageId} style={'height:' + attrs.height + 'px;' + 'width:' + attrs.width + 'px;'}>
		//             {this.$slots.default && this.$slots.default()}
		//         </div>
		//     );
		// },
		mounted() {
			this.drawPage();
		},
		methods: {
			drawPage() {
				if (this.renderTask) return;

				this.isLoaded = false;

				//GENERATES THE CANVAS IN MEMORY
				const myCanvas = document.createElement('canvas');
				myCanvas.height = this.canvasAttrs.height;
				myCanvas.width = this.canvasAttrs.width;

				const { viewport } = this;
				const canvasContext = myCanvas.getContext('2d');
				const renderContext = { canvasContext, viewport };

				//RENDERS THE PDF
				this.renderTask = this.page.render(renderContext);
				this.renderTask.promise.then(() => {
					this.isLoaded = true;
					this.$emit('rendered', { page: this.page, index: this.index });
					this.$refs.pageContainer?.appendChild(myCanvas); //APPENDS FINAL CANVAS TO THE DOM
				});
				this.renderTask.promise.then(/* */).catch(this.destroyRenderTask); //CLEAN UP
			},
			destroyPage(page) {
				if (!page) return;

				page._destroy();
				if (this.renderTask) {
					this.renderTask.cancel();
					this.$emit('error');
				}
			},

			destroyRenderTask() {
				if (!this.renderTask) return;

				this.renderTask.cancel();
				delete this.renderTask;
			},
		},
		watch: {
			page(page, oldPage) {
				this.destroyPage(oldPage);
			},
		},
		components: {},
		beforeUnmount() {
			this.destroyPage(this.page);
		},
	};
</script>
<style>
	.page-container {
		margin: 0 !important;
		padding: 0 !important;
		position: relative;
	}
</style>
